import {lazy} from "react";
import {ROUTE_PATHS} from "./RouterPaths";

const LazyAbout = lazy(() => import("../pages/about/About"));
const LazyTransferPage = lazy(() => import("../pages/transfer/TransferPage"));
const LazyDownloadPage = lazy(() => import("../pages/download/DownloadExportPage"));
const LazyRecipeResultPage = lazy(() => import("../pages/RecipeCustomization/recipeAi/RecipeResultPage"));
const LazyPersonalOrderPage = lazy(() => import("../pages/personal/order/PersonalOrderPage"));
const LazyPersonalVIPPage = lazy(() => import("../pages/vip/router/PersonalVIPPage"));
const LazyMemberAgreementPage = lazy(() => import("../pages/vip/MemberAgreementPage"));
const LazyAiHealthReport = lazy(() => import("../pages/NutritionAssessment/AiHealthReport"));
const LazyPrivacyPolicy = lazy(() => import("../pages/LoginPage/PrivacyPolicy/PrivacyPolicy"));
const LazyUserAgreement = lazy(() => import("../pages/LoginPage/UserAgreement/UserAgreement"));
const RecipeHistoryPage = lazy(() => import("../pages/recipeHistory/RecipeHistoryPage"));

export const routes = [
    { path: ROUTE_PATHS.about, element: <LazyAbout />, name: 'about' },
    { path: ROUTE_PATHS.downloadTransfer, element: <LazyTransferPage />, name: 'download/transfer' },
    { path: ROUTE_PATHS.downloadFile, element: <LazyDownloadPage />, name: 'download/file' },
    { path: ROUTE_PATHS.RecipeResultPage, element: <LazyRecipeResultPage />, name: 'RecipeResultPage' },
    { path: ROUTE_PATHS.PersonalVIP, element: <LazyPersonalVIPPage />, name: 'PersonalVIP' },
    { path: ROUTE_PATHS.personalOrder, element: <LazyPersonalOrderPage />, name: 'personalOrder' },
    { path: ROUTE_PATHS.MemberAgreement, element: <LazyMemberAgreementPage />, name: 'MemberAgreement' },
    { path: ROUTE_PATHS.ReportResult, element: <LazyAiHealthReport />, name: 'ReportResult' },
    { path: ROUTE_PATHS.PrivacyPolicy, element: <LazyPrivacyPolicy />, name: 'PrivacyPolicy' },
    { path: ROUTE_PATHS.UserAgreement, element: <LazyUserAgreement />, name: 'UserAgreement' },
    // 生酮AI(agentId==6) / 营养评估AI(agentId==9) / 食谱定制AI(agentId==7) / 运动营养AI(agentId==8)
    // 这 4 个对话页需要保活缓存（切页不卸载），已迁移到 ConversationKeepAlive 中常驻渲染：
    // - 实际组件注册见 src/router/ConversationKeepAlive.jsx 的 CONVERSATION_KEEP_ALIVE_ROUTES
    // - App.js 中为这些 path 注册 element=null 的占位路由，避免落到 * 兜底路由
    // 生酮、智慧配餐、食谱定制历史记录
    { path: ROUTE_PATHS.RecipeHistory, element: <RecipeHistoryPage />, name: 'RecipeHistory' },
];